/**
 * @generated SignedSource<<6d9522821e76009fac4f02c6164d8dd8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedDealerDetailsReviewContainerLazy_seller$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedDealerDetailsReviewContainer_seller">;
  readonly " $fragmentType": "PdpSharedDealerDetailsReviewContainerLazy_seller";
};
export type PdpSharedDealerDetailsReviewContainerLazy_seller$key = {
  readonly " $data"?: PdpSharedDealerDetailsReviewContainerLazy_seller$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedDealerDetailsReviewContainerLazy_seller">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedDealerDetailsReviewContainerLazy_seller",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedDealerDetailsReviewContainer_seller"
    }
  ],
  "type": "Seller",
  "abstractKey": null
};

(node as any).hash = "9bc6f23bb4a9cba5343fb1eec1ae4999";

export default node;
